
(function(){
"use strict";
var root=document.getElementById("ekg-root");
if(!root||root.dataset.initialized==="1")return;
root.dataset.initialized="1";
function el(id){return root.querySelector("#"+id);}
var fields={principal:el("ekg-principal"),rate:el("ekg-rate"),payment:el("ekg-payment"),extra:el("ekg-extra"),start:el("ekg-start-month"),slider:el("ekg-slider")};
var errors={principal:el("ekg-principal-error"),rate:el("ekg-rate-error"),payment:el("ekg-payment-error"),extra:el("ekg-extra-error"),start:el("ekg-start-error")};
var fmt=new Intl.NumberFormat("nb-NO",{maximumFractionDigits:0});
var fmtRate=new Intl.NumberFormat("nb-NO",{maximumFractionDigits:3});
var csvNum=new Intl.NumberFormat("nb-NO",{useGrouping:false,minimumFractionDigits:2,maximumFractionDigits:2});
var money=function(n){return fmt.format(Math.round(n))+" kr";};
var last=null;
var today=new Date();
fields.start.value=today.getFullYear()+"-"+String(today.getMonth()+1).padStart(2,"0");
fields.start.min=fields.start.value;

function amount(text){
 var s=String(text).replace(/[\s\u00a0\u202f]/g,"").trim();
 if(!s)return null;
 var intPart;
 if(/^\d+(?:,\d{1,2})?$/.test(s))intPart=s.split(",")[0];
 else if(/^\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?$/.test(s))intPart=s.split(",")[0].replace(/\./g,"");
 else if(/^\d+\.\d{1,2}$/.test(s))intPart=s.split(".")[0];
 else return null;
 var n=Number(intPart);
 return Number.isSafeInteger(n)?n:null;
}
function rateNumber(text){
 var s=String(text).replace(/\s/g,"").trim();
 if(!/^\d+(?:[.,]\d{1,3})?$/.test(s))return null;
 var n=Number(s.replace(",","."));
 return Number.isFinite(n)?n:null;
}
function validMonth(text){
 if(!/^\d{4}-(0[1-9]|1[0-2])$/.test(String(text)))return false;
 var year=Number(text.slice(0,4));
 return year>=2000&&year<=2200&&String(text)>=fields.start.min;
}
function setError(key,message){
 var target=errors[key];
 if(target){target.textContent=message||"";target.classList.toggle("ekg-hidden",!message);}
 if(fields[key])fields[key].setAttribute("aria-invalid",message?"true":"false");
}
function showGeneral(message){
 var target=el("ekg-general-error"); target.textContent=message||"";target.classList.toggle("ekg-hidden",!message);
}
function setInvalid(){
 last=null;
 el("ekg-output").classList.add("ekg-hidden");
 el("ekg-vis").classList.add("ekg-hidden");
 el("ekg-download").disabled=true;
}
function readInputs(){
 var v={};
 var specifications=[
  ["principal","Skriv inn et gyldig gjeldsbeløp fra 1 til 100 millioner kr.",1,100000000],
  ["payment","Skriv inn en gyldig månedlig betaling over 0 kr.",1,100000000],
  ["extra","Ekstra innbetaling må være mellom 0 og 5 millioner kr.",0,5000000]
 ];
 var ok=true;
 specifications.forEach(function(spec){
  var key=spec[0],n=amount(fields[key].value);
  var message=(n===null||n<spec[2]||n>spec[3])?spec[1]:"";
  setError(key,message);if(message)ok=false;v[key]=n;
 });
 v.rate=rateNumber(fields.rate.value);
 var rateError=v.rate===null||v.rate<0||v.rate>100?"Oppgi en gyldig nominell rente mellom 0 og 100 %. Bruk gjerne komma, for eksempel 5,5.":"";
 setError("rate",rateError);if(rateError)ok=false;
 v.start=fields.start.value;
 var monthError=validMonth(v.start)?"":"Velg denne måneden eller en senere måned for første innbetaling.";
 setError("start",monthError);if(monthError)ok=false;
 return ok?v:null;
}
function amortize(principal,rate,payment){
 var balance=Math.round(principal*100),pay=Math.round(payment*100),totalInterest=0,rows=[];
 var mr=rate/1200;
 if(pay<=0)return null;
 for(var month=1;month<=1200&&balance>0;month++){
  var opening=balance;
  var interest=Math.round(opening*mr);
  if(pay<=interest)return null;
  var paid=Math.min(pay,opening+interest);
  var reduction=paid-interest;
  balance=Math.max(0,opening-reduction);
  totalInterest+=interest;
  rows.push({month:month,opening:opening/100,interest:interest/100,paid:paid/100,reduction:reduction/100,balance:balance/100});
 }
 if(balance>0)return null;
 return {months:rows.length,interest:totalInterest/100,totalPaid:(Math.round(principal*100)+totalInterest)/100,rows:rows};
}
function duration(months){
 var y=Math.floor(months/12),m=months%12;
 return (y?y+" år":"")+(y&&m?" og ":"")+(m?m+" mnd":"")||"0 mnd";
}
function monthDate(start,index){
 var y=Number(start.slice(0,4)),m=Number(start.slice(5,7))-1;
 return new Date(y,m+index,1);
}
function dateString(start,months){
 return monthDate(start,months-1).toLocaleDateString("nb-NO",{month:"long",year:"numeric"});
}
function csvMonth(start,index){
 var d=monthDate(start,index);
 return String(d.getMonth()+1).padStart(2,"0")+"."+d.getFullYear();
}
function short(n){
 if(n>=1000000)return fmtRate.format(n/1000000)+" mill.";
 if(n>=1000)return fmt.format(Math.round(n/1000))+"k";
 return fmt.format(Math.round(n));
}
function timeLabel(n){
 if(n===0)return "0";
 if(n<12)return n+" mnd";
 return n%12===0?(n/12)+" år":fmtRate.format(n/12)+" år";
}
function renderChart(base,more,principal){
 var compact=!!(window.matchMedia&&window.matchMedia("(max-width: 620px)").matches);
 var W=compact?460:940,H=310,L=compact?92:95,R=compact?20:30,T=20,B=52;
 var xmax=Math.max(1,base?base.months:more.months),maxDebt=principal;
 var x=function(n){return L+(W-L-R)*n/xmax;};
 var y=function(n){return T+(H-T-B)*(1-n/maxDebt);};
 function poly(plan){
  if(!plan)return "";
  var pts=["M"+x(0).toFixed(1)+" "+y(plan.rows[0].opening).toFixed(1)];
  plan.rows.forEach(function(row){pts.push("L"+x(row.month).toFixed(1)+" "+y(row.balance).toFixed(1));});
  return pts.join(" ");
 }
 var xticks=compact?[0,Math.round(xmax/2),xmax]:[0,Math.round(xmax/4),Math.round(xmax/2),Math.round(xmax*3/4),xmax];
 xticks=xticks.filter(function(n,i){return xticks.indexOf(n)===i;});
 var yticks=compact?[0,.5,1]:[0,.25,.5,.75,1];
 var html="";
 yticks.forEach(function(t){
  var yy=y(maxDebt*t).toFixed(1);
  html+='<line x1="'+L+'" x2="'+(W-R)+'" y1="'+yy+'" y2="'+yy+'" stroke="#e5ece9" stroke-width="1"/>';
  html+='<text x="'+(L-10)+'" y="'+(Number(yy)+5)+'" text-anchor="end" font-size="'+(compact?17:14)+'" fill="#607780">'+short(maxDebt*t)+"</text>";
 });
 xticks.forEach(function(n){
  html+='<text x="'+x(n).toFixed(1)+'" y="'+(H-17)+'" text-anchor="middle" font-size="'+(compact?17:14)+'" fill="#607780">'+timeLabel(n)+"</text>";
 });
 if(base)html+='<path d="'+poly(base)+'" fill="none" stroke="#98aab6" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>';
 html+='<path d="'+poly(more)+'" fill="none" stroke="#1a8566" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>';
 var svg=el("ekg-chart-svg");
 svg.setAttribute("viewBox","0 0 "+W+" "+H);
 svg.setAttribute("aria-label",base?"Restgjeld sammenlignet over "+duration(base.months)+". Med ekstra innbetaling: "+duration(more.months)+".":"Restgjeld med ekstra betaling. Gjeldfri på "+duration(more.months)+".");
 svg.innerHTML=html;
 var legend=el("ekg-chart-base-legend");if(legend)legend.textContent=base?"Dagens betaling":"Dagens betaling (for lav)";
}
function presets(extra){
 root.querySelectorAll("[data-ekg-preset]").forEach(function(b){
  b.setAttribute("aria-pressed",Number(b.getAttribute("data-ekg-preset"))===extra?"true":"false");
 });
 var limit=Math.max(10000,Math.ceil(extra/1000)*1000);
 fields.slider.max=String(limit);
 fields.slider.step="1";
 fields.slider.value=String(extra);
 var percent=100*extra/limit;
 fields.slider.style.background="linear-gradient(to right,#2c8a69 0%,#2c8a69 "+percent+"%,#d1e4d7 "+percent+"%,#d1e4d7 100%)";
}
function render(){
 showGeneral("");
 var v=readInputs();if(!v){setInvalid();return;}
 var base=amortize(v.principal,v.rate,v.payment);
 var more=amortize(v.principal,v.rate,v.payment+v.extra);
 if(!more){
  showGeneral("Betalingen er for lav til at gjelden kan nedbetales innen 100 år. Prøv et høyere månedsbeløp eller en lavere rente.");
  setInvalid();return;
 }
 var baseOk=!!base;
 var saved=baseOk?Math.max(0,base.interest-more.interest):null;
 var savedMonths=baseOk?base.months-more.months:null;
 var displaySavings=el("ekg-saving");
 el("ekg-result-heading").textContent=baseOk?"Din mulige rentebesparelse":"Ekstra betaling gjør nedbetaling mulig";
 displaySavings.textContent=baseOk?money(saved):"Mulig";
 displaySavings.classList.toggle("ekg-savings-word",!baseOk);
 el("ekg-saving-copy").textContent=baseOk?(v.extra>0?"Med "+money(v.extra)+" ekstra hver måned kan du redusere totale rentekostnader.":"Prøv en ekstra månedlig innbetaling for å se hva du kan spare."):"Dagens betaling er ikke tilstrekkelig til å nedbetale lånet. Med ekstra betaling viser vi en gjennomførbar plan.";
 el("ekg-early").textContent=baseOk?(savedMonths>0?"Gjeldfri "+duration(savedMonths)+" tidligere":v.extra>0?"Lavere rentekostnader":"Se effekten av ekstra innbetaling"):"Gjeldfri om "+duration(more.months);
 el("ekg-base-duration").textContent=baseOk?duration(base.months):"For lav betaling";
 el("ekg-more-duration").textContent=duration(more.months);
 el("ekg-base-date").textContent=baseOk?"Gjeldfri "+dateString(v.start,base.months):"Lånet blir ikke nedbetalt";
 el("ekg-more-date").textContent="Gjeldfri "+dateString(v.start,more.months);
 el("ekg-base-interest").textContent=baseOk?money(base.interest):"–";
 el("ekg-more-interest").textContent=money(more.interest);
 el("ekg-total-paid").textContent=money(more.totalPaid);
 el("ekg-total-saving").textContent=baseOk?money(saved):"Ikke beregnbart";
 el("ekg-more-label").textContent=v.extra>0?"Med ekstra innbetaling":"Samme betalingsplan";
 el("ekg-caption").textContent="Fast nominell rente: "+fmtRate.format(v.rate)+" %. Første innbetaling: "+monthDate(v.start,0).toLocaleDateString("nb-NO",{month:"long",year:"numeric"})+". Ingen gebyrer eller rentefradrag er inkludert.";
 el("ekg-output").classList.remove("ekg-hidden");
 el("ekg-vis").classList.remove("ekg-hidden");
 el("ekg-download").disabled=false;
 renderChart(base,more,v.principal);
 presets(v.extra);
 last={base:base,more:more,v:v};
}
["principal","payment","extra"].forEach(function(key){
 fields[key].addEventListener("input",render);
 fields[key].addEventListener("blur",function(){
  var n=amount(fields[key].value);
  if(n!==null)fields[key].value=fmt.format(n);
  render();
 });
});
fields.rate.addEventListener("input",render);
fields.rate.addEventListener("blur",function(){
 var n=rateNumber(fields.rate.value);
 if(n!==null&&n>=0&&n<=100)fields.rate.value=fmtRate.format(n);
 render();
});
fields.start.addEventListener("input",render);
fields.start.addEventListener("change",render);
fields.slider.addEventListener("input",function(){
 fields.extra.value=fmt.format(Math.round(Number(fields.slider.value)/100)*100);
 render();
});
root.querySelectorAll("[data-ekg-preset]").forEach(function(b){
 b.addEventListener("click",function(){fields.extra.value=fmt.format(Number(b.getAttribute("data-ekg-preset")));render();});
});
el("ekg-download").addEventListener("click",function(){
 if(!last)return;
 var d=last,base=d.base,more=d.more,v=d.v;
 var lines=["Måned;Betalingsmåned;Gjeld ved start uten ekstra (kr);Renter uten ekstra (kr);Innbetalt uten ekstra (kr);Restgjeld uten ekstra (kr);Gjeld ved start med ekstra (kr);Renter med ekstra (kr);Innbetalt med ekstra (kr);Restgjeld med ekstra (kr)"];
 var count=Math.max(base?base.months:0,more.months);
 function c(n){return n===null||n===undefined?"":csvNum.format(n);}
 for(var i=0;i<count;i++){
  var a=base&&base.rows[i],b=more.rows[i];
  lines.push([i+1,csvMonth(v.start,i),c(a?a.opening:null),c(a?a.interest:null),c(a?a.paid:null),c(a?a.balance:null),c(b?b.opening:null),c(b?b.interest:null),c(b?b.paid:null),c(b?b.balance:null)].join(";"));
 }
 lines.push("");
 lines.push("Forutsetninger: nominell rente "+fmtRate.format(v.rate)+" %, første betaling "+csvMonth(v.start,0)+", månedlig betaling ved månedsslutt, uten gebyrer eller rentefradrag.");
 var blob=new Blob(["\ufeff"+lines.join("\r\n")],{type:"text/csv;charset=utf-8;"});
 var url=URL.createObjectURL(blob),link=document.createElement("a");
 link.href=url;link.download="EnkelExcel-nedbetalingsplan.csv";
 document.body.appendChild(link);link.click();link.remove();
 setTimeout(function(){URL.revokeObjectURL(url);},1000);
});
window.addEventListener("resize",function(){if(last)renderChart(last.base,last.more,last.v.principal);});
render();
})();
